// src/SubscriptionForm.js
import React, { useState } from 'react';
import axios from 'axios'; // Make sure to install axios using "npm install axios".

function SubscriptionForm() {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('http://3.222.60.65:3000/subscribe', { email });

      if (response.status === 200) {
        // Show a success alert when the response is 200 (OK).
        window.alert('Subscription successful!');
        // Optionally, you can reset the form or perform other actions.
      }
       else if (response.status === 409) {
        // Show a conflict alert when the response is 409 (Conflict).
        window.alert('Email is already subscribed.');
        // Optionally, you can reset the form or perform other actions.
      }
    } catch (error) {
      // window.alert('Subscription failed. Please try again.');
      console.error('Subscription failed:', error.response.data.error);
      // Handle other errors if needed, e.g., display an error message to the user.
    }
  };

  return (
    <div>
      <h2>Subscribe to Our Mailing List</h2>
      <p>We will let you know when we launch</p>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Subscribe</button>
      </form>
    </div>
  );
}

export default SubscriptionForm;
